import { ColorableSVG } from "../ColorableSVG";
import { AssembleIconProps } from "../types";

export const ErrorColorIcon = ({
  height = "16px",
  width = "17px",
  ...props
}: AssembleIconProps): JSX.Element => (
  <ColorableSVG {...props}>
    <svg
      width={width}
      height={height}
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="8.5" cy="8" r="7" fill="url(#paint0_linear_2998_89906)" />
      <path d="M10.5 6L6.5 9.99999L10.5 6Z" fill="#0A2440" />
      <path
        d="M10.5 6L6.5 9.99999"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M10.5 10L6.5 6L10.5 10Z" fill="#0A2440" />
      <path
        d="M10.5 10L6.5 6"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2998_89906"
          x1="4.825"
          y1="5.55"
          x2="11.3"
          y2="15"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF385C" />
          <stop offset="1" stopColor="#D91D4A" />
        </linearGradient>
      </defs>
    </svg>
  </ColorableSVG>
);
